import React from 'react'
import { Popover, Popconfirm } from 'antd'
import { PopoverProps } from 'antd/es/popover'
import { PopconfirmProps } from 'antd/es/popconfirm'

export const withPopover = (config: PopoverProps) => (
  Component: React.ReactNode,
) => <Popover {...config}>{Component}</Popover>

export const withPopconfirm = (config: PopconfirmProps) => (
  Component: React.ReactNode,
) => <Popconfirm {...config}>{Component}</Popconfirm>
